// import React, { useEffect, useRef, useState } from "react";
// import constructionteam from "../images/constrcutionteamphoto.jpg"
// const About = () => {
//   const sectionRef = useRef(null);
//   const [visible, setVisible] = useState(false);

//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       ([entry]) => {
//         if (entry.isIntersecting) {
//           setVisible(true);
//         }
//       },
//       { threshold: 0.15 }
//     );

//     if (sectionRef.current) {
//       observer.observe(sectionRef.current);
//     }

//     return () => observer.disconnect();
//   }, []);

//   const capabilities = [
//     {
//       number: "01",
//       title: "Detailed Quantity Takeoffs",
//       text: "We measure and quantify materials from construction drawings to create organized, trade-specific takeoffs.",
//     },
//     {
//       number: "02",
//       title: "Construction Cost Estimates",
//       text: "We develop detailed project cost estimates covering materials, labor, equipment, and applicable project requirements.",
//     },
//     {
//       number: "03",
//       title: "Bid Support",
//       text: "Our estimating support helps contractors review project costs, prepare competitive bids, and make informed decisions.",
//     },
//     {
//       number: "04",
//       title: "Multi-Division Expertise",
//       text: "Our estimating workflow supports multiple CSI divisions across commercial and construction projects.",
//     },
//   ];

//   return (
//     <>
//       <style>{`

//         /* =====================================
//            ABOUT SECTION
//         ===================================== */

//         .sg-about {
//           position: relative;
//           overflow: hidden;
//           padding: 120px 0;
//           background: #ffffff;
//         }

//         .sg-about-container {
//           width: min(1380px, 92%);
//           margin: auto;
//         }

//         /* Background blueprint */
//         .sg-about-blueprint {
//           position: absolute;
//           top: 0;
//           right: -150px;
//           width: 600px;
//           height: 600px;
//           opacity: 0.35;
//           pointer-events: none;

//           background-image:
//             linear-gradient(
//               rgba(25, 91, 180, 0.06) 1px,
//               transparent 1px
//             ),
//             linear-gradient(
//               90deg,
//               rgba(25, 91, 180, 0.06) 1px,
//               transparent 1px
//             );

//           background-size: 35px 35px;

//           transform: rotate(8deg);
//         }

//         /* =====================================
//            SECTION HEADING
//         ===================================== */

//         .sg-about-heading {
//           max-width: 720px;
//           margin-bottom: 65px;

//           opacity: 0;
//           transform: translateY(25px);

//           transition:
//             opacity 0.7s ease,
//             transform 0.7s ease;
//         }

//         .sg-about-heading.visible {
//           opacity: 1;
//           transform: translateY(0);
//         }

//         .sg-about-label {
//           display: inline-flex;
//           align-items: center;
//           gap: 9px;

//           margin-bottom: 17px;

//           color: #175bc3;

//           font-size: 12px;
//           font-weight: 800;

//           letter-spacing: 1.4px;
//           text-transform: uppercase;
//         }

//         .sg-about-label-line {
//           width: 30px;
//           height: 2px;

//           border-radius: 10px;

//           background: #f39818;
//         }

//         .sg-about-title {
//           margin: 0;

//           color: #10213f;

//           font-size: clamp(38px, 4.2vw, 62px);
//           line-height: 1.05;

//           letter-spacing: -2.5px;
//           font-weight: 800;
//         }

//         .sg-about-title span {
//           color: #1b60c8;
//         }

//         .sg-about-intro {
//           max-width: 650px;

//           margin: 20px 0 0;

//           color: #657389;

//           font-size: 17px;
//           line-height: 1.75;
//         }

//         /* =====================================
//            MAIN ABOUT GRID
//         ===================================== */

//         .sg-about-grid {
//           display: grid;

//           grid-template-columns:
//             minmax(0, 0.95fr)
//             minmax(0, 1.05fr);

//           gap: 85px;

//           align-items: center;
//         }

//         /* =====================================
//            IMAGE AREA
//         ===================================== */

//         .sg-about-images {
//           position: relative;

//           min-height: 610px;

//           opacity: 0;
//           transform: translateX(-35px);

//           transition:
//             opacity 0.8s ease,
//             transform 0.8s ease;
//         }

//         .sg-about-images.visible {
//           opacity: 1;
//           transform: translateX(0);
//         }

//         .sg-main-image {
//           position: absolute;

//           top: 0;
//           left: 0;

//           width: 78%;
//           height: 465px;

//           object-fit: cover;

//           border-radius: 22px;

//           box-shadow:
//             0 25px 60px rgba(24, 56, 94, 0.18);
//         }

//         .sg-image-overlay {
//           position: absolute;

//           top: 0;
//           left: 0;

//           width: 78%;
//           height: 465px;

//           border-radius: 22px;

//           background:
//             linear-gradient(
//               180deg,
//               rgba(16, 48, 91, 0.02),
//               rgba(16, 48, 91, 0.30)
//             );

//           pointer-events: none;
//         }

//         .sg-secondary-image {
//           position: absolute;

//           right: 0;
//           bottom: 20px;

//           width: 52%;
//           height: 255px;

//           object-fit: cover;

//           border: 10px solid #ffffff;

//           border-radius: 20px;

//           box-shadow:
//             0 20px 50px rgba(25, 56, 95, 0.18);
//         }

//         /* Image badge */

//         .sg-about-image-badge {
//           position: absolute;

//           z-index: 5;

//           left: 30px;
//           bottom: 42px;

//           display: flex;
//           align-items: center;
//           gap: 13px;

//           padding: 14px 18px;

//           border-radius: 13px;

//           background: rgba(255, 255, 255, 0.94);

//           box-shadow:
//             0 16px 40px rgba(25, 55, 90, 0.15);

//           backdrop-filter: blur(12px);

//           animation: sgAboutFloat 4s ease-in-out infinite;
//         }

//         .sg-about-image-badge-icon {
//           width: 42px;
//           height: 42px;

//           display: flex;
//           align-items: center;
//           justify-content: center;

//           border-radius: 10px;

//           background: #eaf2ff;

//           color: #175bc3;

//           font-size: 19px;
//         }

//         .sg-about-image-badge strong {
//           display: block;

//           color: #10213f;

//           font-size: 15px;
//         }

//         .sg-about-image-badge span {
//           display: block;

//           margin-top: 3px;

//           color: #7a8799;

//           font-size: 10px;
//         }

//         /* =====================================
//            EXPERIENCE CARD
//         ===================================== */

//         .sg-experience-card {
//           position: absolute;

//           z-index: 6;

//           top: 40px;
//           right: 4px;

//           width: 150px;
//           padding: 20px 17px;

//           border-radius: 16px;

//           background:
//             linear-gradient(
//               145deg,
//               #1558c0,
//               #2874dd
//             );

//           color: white;

//           box-shadow:
//             0 18px 40px rgba(21, 88, 192, 0.28);

//           animation: sgAboutFloat 4.5s ease-in-out infinite;
//           animation-delay: 0.6s;
//         }

//         .sg-experience-number {
//           font-size: 34px;
//           line-height: 1;

//           font-weight: 900;
//         }

//         .sg-experience-text {
//           margin-top: 8px;

//           font-size: 11px;
//           line-height: 1.5;

//           opacity: 0.9;
//         }

//         .sg-experience-line {
//           width: 38px;
//           height: 2px;

//           margin-top: 15px;

//           background: #f6a52c;
//         }

//         /* =====================================
//            CONTENT
//         ===================================== */

//         .sg-about-content {
//           opacity: 0;
//           transform: translateX(35px);

//           transition:
//             opacity 0.8s ease 0.15s,
//             transform 0.8s ease 0.15s;
//         }

//         .sg-about-content.visible {
//           opacity: 1;
//           transform: translateX(0);
//         }

//         .sg-about-content-label {
//           color: #f39818;

//           font-size: 12px;
//           font-weight: 800;

//           letter-spacing: 1.3px;
//           text-transform: uppercase;
//         }

//         .sg-about-content-title {
//           max-width: 620px;

//           margin: 12px 0 20px;

//           color: #10213f;

//           font-size: clamp(28px, 3vw, 43px);

//           line-height: 1.15;

//           letter-spacing: -1.4px;

//           font-weight: 800;
//         }

//         .sg-about-content-title span {
//           color: #1b60c8;
//         }

//         .sg-about-content-text {
//           margin: 0 0 18px;

//           color: #657389;

//           font-size: 15px;

//           line-height: 1.75;
//         }

//         /* =====================================
//            CHECK LIST
//         ===================================== */

//         .sg-about-checks {
//           display: grid;

//           grid-template-columns: 1fr 1fr;

//           gap: 13px;

//           margin: 28px 0 35px;
//         }

//         .sg-about-check {
//           display: flex;
//           align-items: center;
//           gap: 10px;

//           color: #35445c;

//           font-size: 13px;
//           font-weight: 600;
//         }

//         .sg-check-icon {
//           width: 24px;
//           height: 24px;

//           flex-shrink: 0;

//           display: flex;
//           align-items: center;
//           justify-content: center;

//           border-radius: 50%;

//           color: #1c8c5a;

//           background: #e9f8f0;

//           font-size: 11px;
//           font-weight: 900;
//         }

//         /* =====================================
//            CAPABILITIES
//         ===================================== */

//         .sg-capabilities {
//           display: grid;

//           grid-template-columns: 1fr 1fr;

//           gap: 14px;

//           margin-top: 45px;
//         }

//         .sg-capability {
//           position: relative;

//           padding: 24px;

//           border: 1px solid #e2eaf3;

//           border-radius: 15px;

//           background: #ffffff;

//           transition:
//             transform 0.25s ease,
//             box-shadow 0.25s ease,
//             border-color 0.25s ease;
//         }

//         .sg-capability:hover {
//           transform: translateY(-5px);

//           border-color: #c9daf0;

//           box-shadow:
//             0 18px 40px rgba(27, 72, 121, 0.09);
//         }

//         .sg-capability-number {
//           color: #d8e4f3;

//           font-size: 32px;
//           font-weight: 900;

//           line-height: 1;
//         }

//         .sg-capability-title {
//           margin: 12px 0 8px;

//           color: #162844;

//           font-size: 15px;
//           font-weight: 800;
//         }

//         .sg-capability-text {
//           margin: 0;

//           color: #7a8799;

//           font-size: 12px;
//           line-height: 1.65;
//         }

//         /* =====================================
//            BOTTOM STRIP
//         ===================================== */

//         .sg-about-strip {
//           display: grid;

//           grid-template-columns: repeat(3, 1fr);

//           margin-top: 90px;

//           padding: 27px 0;

//           border-top: 1px solid #e5ebf3;
//           border-bottom: 1px solid #e5ebf3;
//         }

//         .sg-about-strip-item {
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           gap: 13px;

//           border-right: 1px solid #e5ebf3;
//         }

//         .sg-about-strip-item:last-child {
//           border-right: none;
//         }

//         .sg-about-strip-icon {
//           width: 43px;
//           height: 43px;

//           display: flex;
//           align-items: center;
//           justify-content: center;

//           border-radius: 11px;

//           color: #1558c0;

//           background: #eef5ff;

//           font-size: 18px;
//         }

//         .sg-about-strip strong {
//           display: block;

//           color: #172945;

//           font-size: 14px;
//         }

//         .sg-about-strip span {
//           display: block;

//           margin-top: 4px;

//           color: #8591a2;

//           font-size: 10px;
//         }

//         /* =====================================
//            ANIMATION
//         ===================================== */

//         @keyframes sgAboutFloat {
//           0%,
//           100% {
//             transform: translateY(0);
//           }

//           50% {
//             transform: translateY(-10px);
//           }
//         }

//         /* =====================================
//            TABLET
//         ===================================== */

//         @media (max-width: 1000px) {

//           .sg-about {
//             padding: 90px 0;
//           }

//           .sg-about-grid {
//             gap: 50px;
//           }

//           .sg-about-images {
//             min-height: 500px;
//           }

//           .sg-main-image {
//             height: 380px;
//           }

//           .sg-image-overlay {
//             height: 380px;
//           }

//           .sg-secondary-image {
//             height: 210px;
//           }

//           .sg-experience-card {
//             right: -5px;
//           }

//           .sg-about-checks {
//             grid-template-columns: 1fr;
//           }

//           .sg-capabilities {
//             grid-template-columns: 1fr;
//           }
//         }

//         /* =====================================
//            MOBILE
//         ===================================== */

//         @media (max-width: 760px) {

//           .sg-about {
//             padding: 80px 0;
//           }

//           .sg-about-heading {
//             margin-bottom: 45px;
//             text-align: center;
//           }

//           .sg-about-label {
//             justify-content: center;
//           }

//           .sg-about-title {
//             font-size: 39px;
//             letter-spacing: -1.7px;
//           }

//           .sg-about-intro {
//             font-size: 15px;
//           }

//           .sg-about-grid {
//             grid-template-columns: 1fr;
//             gap: 45px;
//           }

//           .sg-about-images {
//             min-height: 480px;
//             width: 100%;
//           }

//           .sg-main-image {
//             width: 84%;
//             height: 350px;
//           }

//           .sg-image-overlay {
//             width: 84%;
//             height: 350px;
//           }

//           .sg-secondary-image {
//             width: 57%;
//             height: 190px;
//             bottom: 15px;
//           }

//           .sg-experience-card {
//             top: 25px;
//             right: 0;
//           }

//           .sg-about-image-badge {
//             left: 10px;
//             bottom: 30px;
//           }

//           .sg-about-content-title {
//             font-size: 32px;
//           }

//           .sg-about-strip {
//             grid-template-columns: 1fr;
//             gap: 20px;
//             padding: 20px 0;
//           }

//           .sg-about-strip-item {
//             justify-content: flex-start;
//             border-right: none;
//           }
//         }

//         /* =====================================
//            SMALL MOBILE
//         ===================================== */

//         @media (max-width: 480px) {

//           .sg-about {
//             padding: 65px 0;
//           }

//           .sg-about-title {
//             font-size: 35px;
//           }

//           .sg-about-images {
//             min-height: 390px;
//           }

//           .sg-main-image {
//             height: 290px;
//           }

//           .sg-image-overlay {
//             height: 290px;
//           }

//           .sg-secondary-image {
//             height: 155px;
//             border-width: 7px;
//           }

//           .sg-experience-card {
//             width: 125px;
//             padding: 15px;
//           }

//           .sg-experience-number {
//             font-size: 28px;
//           }

//           .sg-experience-text {
//             font-size: 9px;
//           }

//           .sg-about-image-badge {
//             padding: 10px 12px;
//           }

//           .sg-about-image-badge-icon {
//             width: 35px;
//             height: 35px;
//           }

//           .sg-about-image-badge strong {
//             font-size: 12px;
//           }

//           .sg-about-image-badge span {
//             font-size: 8px;
//           }

//           .sg-capability {
//             padding: 19px;
//           }
//         }

//       `}</style>

//       <section
//         className="sg-about"
//         id="about"
//         ref={sectionRef}
//       >

//         <div className="sg-about-blueprint"></div>

//         <div className="sg-about-container">

//           {/* =====================================
//               SECTION HEADING
//           ===================================== */}

//           <div
//             className={`sg-about-heading ${
//               visible ? "visible" : ""
//             }`}
//           >

//             <div className="sg-about-label">
//               <span className="sg-about-label-line"></span>
//               About StructGuard
//             </div>

//             <h2 className="sg-about-title">
//               Turning Construction
//               <br />
//               Plans Into <span>Clear Costs.</span>
//             </h2>

//             <p className="sg-about-intro">
//               StructGuard Construction Services LLP provides
//               professional construction estimating and quantity
//               takeoff services designed to help contractors,
//               builders, and construction professionals understand
//               project costs and bid with confidence.
//             </p>

//           </div>


//           {/* =====================================
//               MAIN CONTENT
//           ===================================== */}

//           <div className="sg-about-grid">

//             {/* IMAGE SIDE */}

//             <div
//               className={`sg-about-images ${
//                 visible ? "visible" : ""
//               }`}
//             >

//               <img
//                 className="sg-main-image"
//                 src="https://images.unsplash.com/photo-1503387762-592deb58ef4e?auto=format&fit=crop&w=1200&q=90"
//                 alt="Construction plans and project development"
//               />

//               <div className="sg-image-overlay"></div>


//               <img
//                 className="sg-secondary-image"
//                 src={constructionteam}
//                 alt="Construction team working on project"
//               />


//               {/* Experience Card */}

//               <div className="sg-experience-card">

//                 <div className="sg-experience-number">
//                   9+
//                 </div>

//                 <div className="sg-experience-text">
//                   CSI divisions supported
//                   across construction
//                   estimating.
//                 </div>

//                 <div className="sg-experience-line"></div>

//               </div>


//               {/* Floating Badge */}

//               <div className="sg-about-image-badge">

//                 <div className="sg-about-image-badge-icon">
//                   ✓
//                 </div>

//                 <div>
//                   <strong>
//                     Estimate Ready
//                   </strong>

//                   <span>
//                     Organized & Bid-Friendly
//                   </span>
//                 </div>

//               </div>

//             </div>


//             {/* CONTENT SIDE */}

//             <div
//               className={`sg-about-content ${
//                 visible ? "visible" : ""
//               }`}
//             >

//               <div className="sg-about-content-label">
//                 OUR APPROACH
//               </div>

//               <h3 className="sg-about-content-title">
//                 Precision at every
//                 <span> stage of estimating.</span>
//               </h3>

//               <p className="sg-about-content-text">
//                 Construction projects depend on accurate numbers.
//                 Our team works with project drawings, specifications,
//                 and construction documents to identify quantities,
//                 organize scope, and develop detailed cost information.
//               </p>

//               <p className="sg-about-content-text">
//                 From individual trades to multi-division projects,
//                 we structure estimates so contractors can quickly
//                 understand project requirements and make informed
//                 bidding decisions.
//               </p>


//               {/* CHECK LIST */}

//               <div className="sg-about-checks">

//                 <div className="sg-about-check">
//                   <span className="sg-check-icon">
//                     ✓
//                   </span>
//                   Detailed quantity takeoffs
//                 </div>

//                 <div className="sg-about-check">
//                   <span className="sg-check-icon">
//                     ✓
//                   </span>
//                   Material & labor estimating
//                 </div>

//                 <div className="sg-about-check">
//                   <span className="sg-check-icon">
//                     ✓
//                   </span>
//                   Multi-division project support
//                 </div>

//                 <div className="sg-about-check">
//                   <span className="sg-check-icon">
//                     ✓
//                   </span>
//                   Bid-ready cost information
//                 </div>

//                 <div className="sg-about-check">
//                   <span className="sg-check-icon">
//                     ✓
//                   </span>
//                   Organized estimating reports
//                 </div>

//                 <div className="sg-about-check">
//                   <span className="sg-check-icon">
//                     ✓
//                   </span>
//                   Contractor-focused workflow
//                 </div>

//               </div>


//               {/* CAPABILITIES */}

//               <div className="sg-capabilities">

//                 {capabilities.map((item) => (

//                   <div
//                     className="sg-capability"
//                     key={item.number}
//                   >

//                     <div className="sg-capability-number">
//                       {item.number}
//                     </div>

//                     <h4 className="sg-capability-title">
//                       {item.title}
//                     </h4>

//                     <p className="sg-capability-text">
//                       {item.text}
//                     </p>

//                   </div>

//                 ))}

//               </div>

//             </div>

//           </div>


//           {/* =====================================
//               BOTTOM TRUST STRIP
//           ===================================== */}

//           <div
//             className={`sg-about-strip ${
//               visible ? "visible" : ""
//             }`}
//           >

//             <div className="sg-about-strip-item">

//               <div className="sg-about-strip-icon">
//                 ◈
//               </div>

//               <div>
//                 <strong>
//                   Construction Focused
//                 </strong>

//                 <span>
//                   Estimating expertise
//                 </span>
//               </div>

//             </div>


//             <div className="sg-about-strip-item">

//               <div className="sg-about-strip-icon">
//                 ≋
//               </div>

//               <div>
//                 <strong>
//                   Detailed Deliverables
//                 </strong>

//                 <span>
//                   Clear & organized estimates
//                 </span>
//               </div>

//             </div>


//             <div className="sg-about-strip-item">

//               <div className="sg-about-strip-icon">
//                 ✓
//               </div>

//               <div>
//                 <strong>
//                   Bid With Confidence
//                 </strong>

//                 <span>
//                   Better cost visibility
//                 </span>
//               </div>

//             </div>

//           </div>

//         </div>

//       </section>
//     </>
//   );
// };

// export default About;



import React, { useEffect, useRef, useState } from "react";
import constructionteam from "../images/constrcutionteamphoto.jpg";

import {
  FiBarChart2,
  FiBriefcase,
  FiCpu,
  FiTool,
  FiCheckCircle,
  FiLayers,
  FiFileText,
  FiUsers,
  FiTarget,
} from "react-icons/fi";

const About = () => {
  const sectionRef = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
        }
      },
      { threshold: 0.15 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const capabilities = [
    {
      number: "01",
      icon: FiBarChart2,
      title: "Construction Estimating",
      text:
        "Detailed quantity takeoffs, material takeoffs, cost estimates, bid preparation, and cost analysis for construction projects.",
    },
    {
      number: "02",
      icon: FiBriefcase,
      title: "Pre-Construction Services",
      text:
        "Budget development, preliminary estimates, scope review, value engineering support, and bid and tender assistance.",
    },
    {
      number: "03",
      icon: FiCpu,
      title: "BIM Services",
      text:
        "BIM modeling, 3D coordination, clash detection, quantity extraction, construction documentation, and BIM-based takeoffs.",
    },
    {
      number: "04",
      icon: FiTool,
      title: "Project Engineering",
      text:
        "Project engineering support, technical documentation, engineering coordination, shop drawing review, and construction support.",
    },
  ];

  const checklist = [
    "Detailed quantity & material takeoffs",
    "Construction cost & budget development",
    "Pre-construction planning support",
    "BIM modeling & coordination",
    "Project engineering support",
    "Clear technical deliverables",
  ];

  return (
    <>
      <style>{`

        /* =====================================
           ABOUT SECTION
        ===================================== */

        .sg-about {
          position: relative;
          overflow: hidden;
          padding: 120px 0;
          background: #ffffff;
        }

        .sg-about-container {
          width: min(1380px, 92%);
          margin: auto;
        }

        /* =====================================
           BACKGROUND BLUEPRINT
        ===================================== */

        .sg-about-blueprint {
          position: absolute;
          top: 0;
          right: -150px;
          width: 600px;
          height: 600px;
          opacity: 0.35;
          pointer-events: none;

          background-image:
            linear-gradient(
              rgba(25, 91, 180, 0.06) 1px,
              transparent 1px
            ),
            linear-gradient(
              90deg,
              rgba(25, 91, 180, 0.06) 1px,
              transparent 1px
            );

          background-size: 35px 35px;

          transform: rotate(8deg);
        }

        .sg-about-blueprint::after {
          content: "";
          position: absolute;
          width: 360px;
          height: 360px;
          right: 90px;
          top: 100px;
          border: 1px solid rgba(25, 91, 180, 0.09);
          transform: rotate(20deg);
        }

        /* =====================================
           SECTION HEADING
        ===================================== */

        .sg-about-heading {
          max-width: 800px;
          margin-bottom: 65px;

          opacity: 0;
          transform: translateY(25px);

          transition:
            opacity 0.7s ease,
            transform 0.7s ease;
        }

        .sg-about-heading.visible {
          opacity: 1;
          transform: translateY(0);
        }

        .sg-about-label {
          display: inline-flex;
          align-items: center;
          gap: 9px;

          margin-bottom: 17px;

          color: #175bc3;

          font-size: 12px;
          font-weight: 800;

          letter-spacing: 1.4px;
          text-transform: uppercase;
        }

        .sg-about-label-line {
          width: 30px;
          height: 2px;

          border-radius: 10px;

          background: #f39818;
        }

        .sg-about-title {
          margin: 0;

          color: #10213f;

          font-size: clamp(38px, 4.2vw, 62px);
          line-height: 1.05;

          letter-spacing: -2.5px;
          font-weight: 800;
        }

        .sg-about-title span {
          color: #1b60c8;
        }

        .sg-about-intro {
          max-width: 730px;

          margin: 20px 0 0;

          color: #657389;

          font-size: 17px;
          line-height: 1.75;
        }

        /* =====================================
           MAIN ABOUT GRID
        ===================================== */

        .sg-about-grid {
          display: grid;

          grid-template-columns:
            minmax(0, 0.95fr)
            minmax(0, 1.05fr);

          gap: 85px;

          align-items: center;
        }

        /* =====================================
           IMAGE AREA
        ===================================== */

        .sg-about-images {
          position: relative;

          min-height: 610px;

          opacity: 0;
          transform: translateX(-35px);

          transition:
            opacity 0.8s ease,
            transform 0.8s ease;
        }

        .sg-about-images.visible {
          opacity: 1;
          transform: translateX(0);
        }

        .sg-main-image {
          position: absolute;

          top: 0;
          left: 0;

          width: 78%;
          height: 465px;

          object-fit: cover;

          border-radius: 22px;

          box-shadow:
            0 25px 60px rgba(24, 56, 94, 0.18);
        }

        .sg-image-overlay {
          position: absolute;

          top: 0;
          left: 0;

          width: 78%;
          height: 465px;

          border-radius: 22px;

          background:
            linear-gradient(
              180deg,
              rgba(16, 48, 91, 0.02),
              rgba(16, 48, 91, 0.30)
            );

          pointer-events: none;
        }

        .sg-secondary-image {
          position: absolute;

          right: 0;
          bottom: 20px;

          width: 52%;
          height: 255px;

          object-fit: cover;

          border: 10px solid #ffffff;

          border-radius: 20px;

          box-shadow:
            0 20px 50px rgba(25, 56, 95, 0.18);
        }

        /* =====================================
           IMAGE BADGE
        ===================================== */

        .sg-about-image-badge {
          position: absolute;

          z-index: 5;

          left: 30px;
          bottom: 42px;

          display: flex;
          align-items: center;
          gap: 13px;

          padding: 14px 18px;

          border-radius: 13px;

          background: rgba(255, 255, 255, 0.95);

          box-shadow:
            0 16px 40px rgba(25, 55, 90, 0.15);

          backdrop-filter: blur(12px);

          animation: sgAboutFloat 4s ease-in-out infinite;
        }

        .sg-about-image-badge-icon {
          width: 42px;
          height: 42px;

          display: flex;
          align-items: center;
          justify-content: center;

          border-radius: 10px;

          background: #eaf2ff;

          color: #175bc3;

          font-size: 19px;
        }

        .sg-about-image-badge strong {
          display: block;

          color: #10213f;

          font-size: 14px;
        }

        .sg-about-image-badge span {
          display: block;

          margin-top: 3px;

          color: #7a8799;

          font-size: 10px;
        }

        /* =====================================
           EXPERIENCE / SERVICE CARD
        ===================================== */

        .sg-experience-card {
          position: absolute;

          z-index: 6;

          top: 40px;
          right: 4px;

          width: 165px;
          padding: 20px 17px;

          border-radius: 16px;

          background:
            linear-gradient(
              145deg,
              #1558c0,
              #2874dd
            );

          color: white;

          box-shadow:
            0 18px 40px rgba(21, 88, 192, 0.28);

          animation: sgAboutFloat 4.5s ease-in-out infinite;
          animation-delay: 0.6s;
        }

        .sg-experience-number {
          font-size: 34px;
          line-height: 1;

          font-weight: 900;
        }

        .sg-experience-text {
          margin-top: 8px;

          font-size: 11px;
          line-height: 1.5;

          opacity: 0.92;
        }

        .sg-experience-line {
          width: 38px;
          height: 2px;

          margin-top: 15px;

          background: #f6a52c;
        }

        /* =====================================
           CONTENT
        ===================================== */

        .sg-about-content {
          opacity: 0;
          transform: translateX(35px);

          transition:
            opacity 0.8s ease 0.15s,
            transform 0.8s ease 0.15s;
        }

        .sg-about-content.visible {
          opacity: 1;
          transform: translateX(0);
        }

        .sg-about-content-label {
          color: #f39818;

          font-size: 12px;
          font-weight: 800;

          letter-spacing: 1.3px;
          text-transform: uppercase;
        }

        .sg-about-content-title {
          max-width: 620px;

          margin: 12px 0 20px;

          color: #10213f;

          font-size: clamp(28px, 3vw, 43px);

          line-height: 1.15;

          letter-spacing: -1.4px;

          font-weight: 800;
        }

        .sg-about-content-title span {
          color: #1b60c8;
        }

        .sg-about-content-text {
          margin: 0 0 18px;

          color: #657389;

          font-size: 15px;

          line-height: 1.75;
        }

        /* =====================================
           CHECK LIST
        ===================================== */

        .sg-about-checks {
          display: grid;

          grid-template-columns: 1fr 1fr;

          gap: 13px;

          margin: 28px 0 35px;
        }

        .sg-about-check {
          display: flex;
          align-items: center;
          gap: 10px;

          color: #35445c;

          font-size: 13px;
          font-weight: 600;
        }

        .sg-check-icon {
          width: 24px;
          height: 24px;

          flex-shrink: 0;

          display: flex;
          align-items: center;
          justify-content: center;

          border-radius: 50%;

          color: #1c8c5a;

          background: #e9f8f0;

          font-size: 11px;
          font-weight: 900;
        }

        /* =====================================
           CAPABILITIES
        ===================================== */

        .sg-capabilities {
          display: grid;

          grid-template-columns: 1fr 1fr;

          gap: 14px;

          margin-top: 45px;
        }

        .sg-capability {
          position: relative;

          padding: 22px;

          border: 1px solid #e2eaf3;

          border-radius: 15px;

          background: #ffffff;

          transition:
            transform 0.25s ease,
            box-shadow 0.25s ease,
            border-color 0.25s ease;
        }

        .sg-capability:hover {
          transform: translateY(-5px);

          border-color: #c9daf0;

          box-shadow:
            0 18px 40px rgba(27, 72, 121, 0.09);
        }

        .sg-capability-top {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 10px;
        }

        .sg-capability-number {
          color: #d8e4f3;

          font-size: 30px;
          font-weight: 900;

          line-height: 1;
        }

        .sg-capability-icon {
          width: 38px;
          height: 38px;

          display: flex;
          align-items: center;
          justify-content: center;

          border-radius: 10px;

          color: #1558c0;

          background: #edf4ff;

          font-size: 17px;
        }

        .sg-capability:nth-child(2) .sg-capability-icon,
        .sg-capability:nth-child(4) .sg-capability-icon {
          color: #e7870c;
          background: #fff4e4;
        }

        .sg-capability-title {
          margin: 14px 0 8px;

          color: #162844;

          font-size: 15px;
          font-weight: 800;
        }

        .sg-capability-text {
          margin: 0;

          color: #7a8799;

          font-size: 12px;
          line-height: 1.65;
        }

        /* =====================================
           BOTTOM STRIP
        ===================================== */

        .sg-about-strip {
          display: grid;

          grid-template-columns: repeat(3, 1fr);

          margin-top: 90px;

          padding: 27px 0;

          border-top: 1px solid #e5ebf3;
          border-bottom: 1px solid #e5ebf3;

          opacity: 0;
          transform: translateY(20px);

          transition:
            opacity 0.7s ease 0.3s,
            transform 0.7s ease 0.3s;
        }

        .sg-about-strip.visible {
          opacity: 1;
          transform: translateY(0);
        }

        .sg-about-strip-item {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 13px;

          border-right: 1px solid #e5ebf3;
        }

        .sg-about-strip-item:last-child {
          border-right: none;
        }

        .sg-about-strip-icon {
          width: 43px;
          height: 43px;

          display: flex;
          align-items: center;
          justify-content: center;

          border-radius: 11px;

          color: #1558c0;

          background: #eef5ff;

          font-size: 18px;
        }

        .sg-about-strip strong {
          display: block;

          color: #172945;

          font-size: 14px;
        }

        .sg-about-strip span {
          display: block;

          margin-top: 4px;

          color: #8591a2;

          font-size: 10px;
        }

        /* =====================================
           ANIMATION
        ===================================== */

        @keyframes sgAboutFloat {
          0%,
          100% {
            transform: translateY(0);
          }

          50% {
            transform: translateY(-10px);
          }
        }

        /* =====================================
           TABLET
        ===================================== */

        @media (max-width: 1000px) {

          .sg-about {
            padding: 90px 0;
          }

          .sg-about-grid {
            gap: 50px;
          }

          .sg-about-images {
            min-height: 500px;
          }

          .sg-main-image {
            height: 380px;
          }

          .sg-image-overlay {
            height: 380px;
          }

          .sg-secondary-image {
            height: 210px;
          }

          .sg-experience-card {
            right: -5px;
          }

          .sg-about-checks {
            grid-template-columns: 1fr;
          }

          .sg-capabilities {
            grid-template-columns: 1fr;
          }
        }

        /* =====================================
           MOBILE
        ===================================== */

        @media (max-width: 760px) {

          .sg-about {
            padding: 80px 0;
          }

          .sg-about-heading {
            margin-bottom: 45px;
            text-align: center;
          }

          .sg-about-label {
            justify-content: center;
          }

          .sg-about-title {
            font-size: 39px;
            letter-spacing: -1.7px;
          }

          .sg-about-intro {
            font-size: 15px;
          }

          .sg-about-grid {
            grid-template-columns: 1fr;
            gap: 45px;
          }

          .sg-about-images {
            min-height: 480px;
            width: 100%;
          }

          .sg-main-image {
            width: 84%;
            height: 350px;
          }

          .sg-image-overlay {
            width: 84%;
            height: 350px;
          }

          .sg-secondary-image {
            width: 57%;
            height: 190px;
            bottom: 15px;
          }

          .sg-experience-card {
            top: 25px;
            right: 0;
          }

          .sg-about-image-badge {
            left: 10px;
            bottom: 30px;
          }

          .sg-about-content-title {
            font-size: 32px;
          }

          .sg-about-strip {
            grid-template-columns: 1fr;
            gap: 20px;
            padding: 20px 0;
          }

          .sg-about-strip-item {
            justify-content: flex-start;
            border-right: none;
          }
        }

        /* =====================================
           SMALL MOBILE
        ===================================== */

        @media (max-width: 480px) {

          .sg-about {
            padding: 65px 0;
          }

          .sg-about-title {
            font-size: 35px;
          }

          .sg-about-images {
            min-height: 390px;
          }

          .sg-main-image {
            height: 290px;
          }

          .sg-image-overlay {
            height: 290px;
          }

          .sg-secondary-image {
            height: 155px;
            border-width: 7px;
          }

          .sg-experience-card {
            width: 125px;
            padding: 15px;
          }

          .sg-experience-number {
            font-size: 28px;
          }

          .sg-experience-text {
            font-size: 9px;
          }

          .sg-about-image-badge {
            padding: 10px 12px;
          }

          .sg-about-image-badge-icon {
            width: 35px;
            height: 35px;
          }

          .sg-about-image-badge strong {
            font-size: 12px;
          }

          .sg-about-image-badge span {
            font-size: 8px;
          }

          .sg-capability {
            padding: 19px;
          }
        }

      `}</style>

      <section
        className="sg-about"
        id="about"
        ref={sectionRef}
      >

        <div className="sg-about-blueprint"></div>

        <div className="sg-about-container">

          {/* =====================================
              SECTION HEADING
          ===================================== */}

          <div
            className={`sg-about-heading ${visible ? "visible" : ""
              }`}
          >

            <div className="sg-about-label">
              <span className="sg-about-label-line"></span>
              About StructGuard
            </div>

            <h2 className="sg-about-title">
              Construction Expertise
              <br />
              Built Around <span>Your Project.</span>
            </h2>

            <p className="sg-about-intro">
              StructGuard Construction Services LLP provides
              construction-focused technical services that help
              contractors, builders, developers, and construction
              professionals make better decisions from project
              planning through execution.
            </p>

          </div>


          {/* =====================================
              MAIN CONTENT
          ===================================== */}

          <div className="sg-about-grid">

            {/* =====================================
                IMAGE SIDE
            ===================================== */}

            <div
              className={`sg-about-images ${visible ? "visible" : ""
                }`}
            >

              <img
                className="sg-main-image"
                src="https://images.unsplash.com/photo-1503387762-592deb58ef4e?auto=format&fit=crop&w=1200&q=90"
                alt="Construction plans and project development"
              />

              <div className="sg-image-overlay"></div>


              <img
                className="sg-secondary-image"
                src={constructionteam}
                alt="StructGuard construction team working on a project"
              />


              {/* Service Areas Card */}

              <div className="sg-experience-card">

                <div className="sg-experience-number">
                  4
                </div>

                <div className="sg-experience-text">
                  Core service areas supporting
                  construction projects from
                  planning through delivery.
                </div>

                <div className="sg-experience-line"></div>

              </div>


              {/* Floating Badge */}

              <div className="sg-about-image-badge">

                <div className="sg-about-image-badge-icon">
                  <FiCheckCircle />
                </div>

                <div>
                  <strong>
                    Project Focused
                  </strong>

                  <span>
                    Technical & Organized Support
                  </span>
                </div>

              </div>

            </div>


            {/* =====================================
                CONTENT SIDE
            ===================================== */}

            <div
              className={`sg-about-content ${visible ? "visible" : ""
                }`}
            >

              <div className="sg-about-content-label">
                OUR APPROACH
              </div>

              <h3 className="sg-about-content-title">
                One technical partner.
                <span> Multiple project capabilities.</span>
              </h3>

              <p className="sg-about-content-text">
                Construction projects require reliable information
                at every stage. Our approach brings estimating,
                pre-construction, BIM, and project engineering
                support together so project teams can work with
                clearer quantities, better cost visibility, and
                organized technical information.
              </p>

              <p className="sg-about-content-text">
                We work with construction drawings, specifications,
                models, project documents, and technical information
                to develop practical deliverables that support
                planning, bidding, coordination, and project
                execution.
              </p>


              {/* =====================================
                  CHECK LIST
              ===================================== */}

              <div className="sg-about-checks">

                {checklist.map((item, index) => (
                  <div
                    className="sg-about-check"
                    key={index}
                  >
                    <span className="sg-check-icon">
                      <FiCheckCircle />
                    </span>

                    {item}
                  </div>
                ))}

              </div>


              {/* =====================================
                  FOUR CAPABILITIES
              ===================================== */}

              <div className="sg-capabilities">

                {capabilities.map((item) => {

                  const Icon = item.icon;

                  return (
                    <div
                      className="sg-capability"
                      key={item.number}
                    >

                      <div className="sg-capability-top">

                        <div className="sg-capability-number">
                          {item.number}
                        </div>

                        <div className="sg-capability-icon">
                          <Icon />
                        </div>

                      </div>

                      <h4 className="sg-capability-title">
                        {item.title}
                      </h4>

                      <p className="sg-capability-text">
                        {item.text}
                      </p>

                    </div>
                  );

                })}

              </div>

            </div>

          </div>


          {/* =====================================
              BOTTOM TRUST STRIP
          ===================================== */}

          <div
            className={`sg-about-strip ${visible ? "visible" : ""
              }`}
          >

            <div className="sg-about-strip-item">

              <div className="sg-about-strip-icon">
                <FiTarget />
              </div>

              <div>
                <strong>
                  Project Focused
                </strong>

                <span>
                  Practical technical support
                </span>
              </div>

            </div>


            <div className="sg-about-strip-item">

              <div className="sg-about-strip-icon">
                <FiLayers />
              </div>

              <div>
                <strong>
                  Integrated Services
                </strong>

                <span>
                  Estimating, BIM & engineering
                </span>
              </div>

            </div>


            <div className="sg-about-strip-item">

              <div className="sg-about-strip-icon">
                <FiFileText />
              </div>

              <div>
                <strong>
                  Clear Deliverables
                </strong>

                <span>
                  Organized project information
                </span>
              </div>

            </div>

          </div>

        </div>

      </section>
    </>
  );
};

export default About;